import React from "react";
import { MDBRow, MDBCol } from 'mdb-react-ui-kit';
import MultipleSelectChip from "../fields/chips";

export default function Testamenti({
    setInfoAggiuntive, 

    setElencoPatrimonio,
    setElencoEredi,
    ElencoPatrimonio,
    ElencoEredi
    }) {
    
    const patrimonio = [
        'Immobili',
        'Conto corrente',
        'Portafoglio titoli',
        'Azienda',
        'Altro'
    ];

    const eredi = [
        'Coniuge',
        'Un solo figlio',
        'Più figli',
        'Genitori',
        'Fratelli e sorelle',
        'Altro'
    ];

	return (
		<>
            <MDBRow>
                <MDBCol>
                <div className="field">
                    <label className='customLab'>Patrimonio</label>
                    <p>Selezionare tutte le caselle rilevanti</p>
                    <MultipleSelectChip 
                    names={patrimonio} 
                    setElement={setElencoPatrimonio}
                    Element={ElencoPatrimonio}
                    />
                </div>
                </MDBCol>
                <MDBCol>
                <div className="field">
                    <label className='customLab'>Eredi</label>
                    <p>Selezionare tutte le caselle rilevanti</p>
                    <MultipleSelectChip 
                    names={eredi} 
                    setElement={setElencoEredi}
                    Element={ElencoEredi}
                    />
                </div>
                </MDBCol>
            </MDBRow>
            
            <MDBRow>
                <div className="field">
                    <label className='customLab' for="message">Informazioni aggiuntive</label>
                    <textarea className="message-field" type="textarea" placeholder="Informazioni" name="infoaggiuntive" id="infoaggiuntive" onChange={e => setInfoAggiuntive(e.target.value)} />
                </div>
            </MDBRow>

            </>
	);
}